import * as yup from "yup";
import { DEFAULT_MESSAGES } from "../defaultMessages";

export const createEspecialidadSchema = yup.object({
  nombre: yup
    .string()
    .strict(true)
    .matches(
      /^[a-zA-ZÁÉÍÓÚáéíóúÑñ]+(?: [a-zA-ZÁÉÍÓÚáéíóúÑñ]+)*$/,
      "Solo se permiten letras y espacios intermedios",
    )
    .min(5, "Debe tener al menos 5 caracteres sin contar espacios")
    .required("El nombre es obligatorio"),
});
